export default [
  {
    id: 1,
    label: "일반작업",
    check: true,
    title: "일반작업",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "양호",
        headerNoTitle: "불량",
        headerNATitle: "N/A",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "• 작업구역 설정(출입경고 표지)",
            is_checked: "",
          },
          {
            id: 2,
            label: "• 가스농도 측정",
            is_checked: "",
          },
          {
            id: 3,
            label: "• 밸브차단 및 차단표지 부착",
            is_checked: "",
          },
          {
            id: 4,
            label: "• 맹판설치 및 표지부착",
            is_checked: "",
          },
          {
            id: 5,
            label: "• 용기개방 및 압력방출",
            is_checked: "",
          },
          {
            id: 6,
            label: "• 위험물질방출 및 처리",
            is_checked: "",
          },
          {
            id: 7,
            label: "• 용기내부 세정 및 처리",
            is_checked: "",
          },
          {
            id: 8,
            label: "• 불활성가스 치환 및 환기",
            is_checked: "",
          },
          {
            id: 9,
            label: "• 정전/잠금/표지부착",
            is_checked: "",
          },
          {
            id: 10,
            label: "• 환기장비",
            is_checked: "",
          },
          {
            id: 11,
            label: "• 조명장비",
            is_checked: "",
          },
          {
            id: 12,
            label: "• 소 화 기",
            is_checked: "",
          },
          {
            id: 13,
            label: "• 안전장구",
            is_checked: "",
          },
          {
            id: 14,
            label: "• 안전교육",
            is_checked: "",
          },
          {
            id: 15,
            label: "• 운전요원의 입회",
            is_checked: "",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    label: "전기차단(정전)작업",
    check: false,
    title: "전기차단(정전)작업",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "양호",
        headerNoTitle: "불량",
        headerNATitle: "N/A",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            title: "제어반",
            id: 1,
            label: "• 주 차단 스위치 내림",
            is_checked: "",
          },
          {
            title: "제어반",
            id: 2,
            label: "• 제어차단기 내림",
            is_checked: "",
          },
          {
            title: "제어반",
            id: 3,
            label: "• 잠금장치",
            is_checked: "",
          },
          {
            title: "제어반",
            id: 4,
            label: "• 시험전원 차단",
            is_checked: "",
          },
          {
            title: "제어반",
            id: 5,
            label: "• 차단표지판 부착",
            is_checked: "",
          },
          {
            title: "현장기기",
            id: 6,
            label: "• 현장스위치 내림",
            is_checked: "",
          },
          {
            title: "현장기기",
            id: 7,
            label: "• 차단표지판 부착",
            is_checked: "",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    label: "고소 작업",
    check: false,
    title: "고소 작업",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "양호",
        headerNoTitle: "불량",
        headerNATitle: "N/A",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "1. 작업에 적합한 작업발판 및 안전난간 설치 여부",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 안전대 착용 및 부착 여부기 내림",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 추락 방지용 방망 설치 여부",
            is_checked: "",
          },
        ],
      },
    ],
  },
];
